/**
 * HeaderNav.tsx — hovednavigasjon i header (midten)
 *
 * Ren React-komponent som erstatter cds-header-nav.
 * Container for HeaderNavItem-lenker.
 *
 * Props:
 * - children: HeaderNavItem-komponenter
 * - ariaLabel: tilgjengelighet-label
 */

import { ReactNode } from 'react';
import styles from './header-nav.module.css';

interface HeaderNavProps {
  children: ReactNode;
  ariaLabel?: string;
}

export default function HeaderNav({ children, ariaLabel = 'Hovednavigasjon' }: HeaderNavProps) {
  return (
    <nav className={styles.nav} aria-label={ariaLabel}>
      <ul className={styles.list}>
        {children}
      </ul>
    </nav>
  );
}
